import { getAccessTokenSilently } from "utils/functions";
import { useHistory } from "react-router-dom";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import DeleteSvgComponent from "assets/icons/svg/DeleteSvg/Delete";
import { InputField, LabelField, MyCheckbox } from "components";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import AlertDialog from "components/Dialog/AlertDialog";
import MyButton from "components/MyButton";
import { getCurrency } from "helper/numberFormat";
import useGetUserAccount from "hook/useGetUserAccount";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toastr } from "react-redux-toastr";
import FinanceService from "../../../../Lib/API/Finance";
import AddInstallmentsPayment from "./AddInstallmentsPayment";
import MyModal from "components/MyModal";
import VerifyAchCardInfo from "components/verifyAchCardInfo/VerifyAchCardInfo";
import { Fonts, FontColors } from "theme/fontConfig";

export const ACH = ({
  formik,
  onPaymentValueChange,
  title,
  totalPaidAmount,
  calculateTotalAmount,
  allowPaymentInstallment,
  enablePaymentInstallments,
  bottomAdd = false,
}) => {
  const enableInstallments = useMemo(
    () => allowPaymentInstallment && enablePaymentInstallments,
    [allowPaymentInstallment, enablePaymentInstallments],
  );

  const [addNewCard, setAddNewCard] = useState(false);
  const [accountDetail, setAccountDetail] = useState({});
  const [achListing, setAchListing] = useState([]);
  const [selectedAch, setSelectedAch] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [achId, setAchId] = useState(null);
  const [checkCard, setCheckCard] = useState(false);
  const [setDefaultLoading, setSetDefaultLoading] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:750px)");
  const routerHistory = useHistory();

  let accountID = localStorage.getItem("accountID")
    ? localStorage.getItem("accountID")
    : "";

  const accountData = useGetUserAccount({ member: true });

  const isOptionalObject = useMemo(() => {
    if (
      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||
      formik["values"]["allPaymentsMethods"].length === 0
    )
      return;

    const currentComponent = formik["values"]["allPaymentsMethods"].find(
      (item) => {
        return item.type === "ach";
      },
    );

    if (!currentComponent ||!currentComponent._id) return;

    return {
 id:currentComponent?._id,
    coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false, 
      isOptional: currentComponent?.convenienceFeeInfo?.optional ?? false,
      message: currentComponent?.convenienceFeeInfo?.message,
      type: currentComponent?.type,
    };
  }, [formik["values"]]);

  useEffect(() => {
    if (!isOptionalObject?.isOptional) return;
    if (!key) return;

    if (formik.values[key] === undefined) {
      formik.setFieldValue(key, true);
    }
  }, [key, isOptionalObject]);

  const key = `${isOptionalObject?.id}`;

  useEffect(() => {
    if (selectedAch) {
      onPaymentValueChange(title, {
        target: {
          value: title,
          name: "paymentMethod",
        },
      });
      onPaymentValueChange(title, {
        target: {
          value: selectedAch.id,
          name: "ACH",
        },
      });
    }
    //eslint-disable-next-line
  }, [selectedAch]);

  const onAccountChange = (event, name) => {
    setAccountDetail({
      ...accountDetail,
      [name]: event.target.value,
    });
    formik.setFieldValue(`account.${name}`, event.target.value);
  };

  const getAchCards = useCallback(async () => {
    const token = await getAccessTokenSilently();
    const res = await FinanceService.getACHCardsByAccountId(
      token,
      accountID ?? "",
    );

    setAchListing(res.ach.data);
    formik.setFieldValue("ACHDetail", res.ach.data);
  }, [getAccessTokenSilently, accountID, formik.values?.selectedACH]);

  React.useEffect(() => {
    if (accountData) {
      accountID = accountData?.user?.permissions?.linked_account?._id;
      getAchCards();
    } else {
      getAchCards();
    }
  }, [accountData]);

  React.useEffect(() => {
    formik.setFieldValue("selectedACH", selectedAch);
  }, [selectedAch]);

  //Handle Submit ACH Account
  const onSaveAccount = async (e) => {
    const token = await getAccessTokenSilently();

    FinanceService.addACHAccount(token, accountID ?? "", accountDetail)
      .then(() => {
        getAchCards();
        formik.setFieldValue(`account.number`, "");
        formik.setFieldValue("account.routing", "");
        formik.setFieldValue("account.type", "");
        formik.setFieldValue("account.name", "");
        // setCardDetail({});
        // setAddNewCard(false);
        toastr.success("Success", "ACH Added Successfully");
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.data?.message ?? "Please enter valid card details",
        );
      });
    e.preventDefault();
  };

  //handle delete ACH

  const onDeleteAch = async (idx) => {
    const token = await getAccessTokenSilently();
    await FinanceService.deleteAchCard(token, idx, accountID ?? "")
      .then(() => {
        getAchCards();
        toastr.success("Success", "ACH Deleted Successfully");
        closeConfirmDialog();
      })
      .catch((error) => {
        console.log(error, "deleteError");
        toastr.error("Error", error?.data?.message);
      });
  };

  //ACH VERIFIED
  const [achNumberOne, setAchNumberOne] = useState("");
  const [achNumberTwo, setAchNumberTwo] = useState("");
  const [achNumberSM, setAchNumberSM] = useState("");

  const handelverifyAch = async (item) => {
    // const data = {
    //   accountId: accountID ?? "",
    //   achId: item?.id,
    //   firstAmount: achNumberOne,
    //   secondAmount: achNumberTwo,
    //   smCode: achNumberSM,
    // };

    let data = {
      accountId: accountID ?? "",
      achId: item?.id,
      firstAmount: achNumberOne || null,
      secondAmount: achNumberTwo || null,
      smCode: achNumberSM || null,
    };

    if (data.firstAmount === null) delete data.firstAmount;
    if (data.secondAmount === null) delete data.secondAmount;
    if (data.smCode === null) delete data.smCode;
    const token = await getAccessTokenSilently();
    const res = await FinanceService.verifyAch(data, token)
      .then(() => {
        getAchCards();
        toastr.success("Success", "Account verified");
      })
      .catch((err) => {
        toastr.error(
          "Error",
          err?.data?.message ?? "Please enter valid details",
        );
      });
  };

  const setCardDefault = async () => {
    if (selectedAch?.id) {
      const token = await getAccessTokenSilently();
      const data = {
        accountId: accountID ?? "",
        achId: selectedAch?.id,
      };
      setSetDefaultLoading(true);
      await FinanceService.setDefaultAch(data, token)
        .then((res) => {
          toastr.success("Success", "Default card is checked!");
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        })
        .finally(() => {
          const timeOut = setTimeout(() => {
            setSetDefaultLoading(false);
          }, 2000);
          return () => {
            clearTimeout(timeOut);
          };
        });
      getAchCards();
    }
  };

  useEffect(() => {
    setCardDefault();
  }, [checkCard]);

  useEffect(() => {
    if (
      !formik?.values?.ach ||
      !achListing?.length ||
      formik?.values?.selectedACH
    )
      return;
    const findDefaultCard = achListing?.find((card) => card?.is_default);
    if (findDefaultCard) {
      setSelectedAch(findDefaultCard);
    } else if (achListing?.length === 1) {
      setSelectedAch(achListing[0]);
    }
  }, [formik?.values?.ach]);

  const onSelectAch = (item) => {
    if (setDefaultLoading) return;
    if (item?.id === selectedAch?.id) {
      setSelectedAch("");
    } else {
      setSelectedAch(item);
    }
  };

  const openConfirmDialog = (id) => {
    setAchId(id);
    setOpenAlert(true);
  };

  const closeConfirmDialog = () => {
    setOpenAlert(false);
    setAchId(null);
  };

  const calculateRemainingBalance = () => {
    return calculateTotalAmount() - totalPaidAmount;
  };

  const openVerifyInfoModal = () => setOpenVerifyModal(true);
  const closeVerifyInfoModal = () => setOpenVerifyModal(false);

  return (
    <>
      <div className="credit-card form-row col-sm-12 justify-content-between px-0 mt-4">
        <div className="d-flex col-sm-7 ">
          <div className="cards-radio font-16">
            {achListing?.map((item) => (
              <div
                key={item.id}
                style={{
                  gap: "1rem",
                }}
                className={`d-flex align-items-center ${
                  setDefaultLoading ? "disabled-card" : ""
                }`}
              >
                <div
                  className="col-sm-3"
                  data-id={item.id}
                  key={item.id}
                  onClick={() => onSelectAch(item)}
                  class={
                    selectedAch?.id === item.id
                      ? "selected-card card-item"
                      : "card-item"
                  }
                >
                  <p>
                    {`${item.nameOnAccount ? item.nameOnAccount : ""} ${
                      item.accountNumber ? "/ " + item.accountNumber : ""
                    }`}
                    <DeleteSvgComponent
                      color={"gray"}
                      onClick={(e) => {
                        e.stopPropagation();
                        openConfirmDialog(item.id);
                      }}
                    />
                  </p>
                </div>
                {item?.status !== "verified" && (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        height: "auto",
                      }}
                    >
                      <input
                        style={{
                          width: "40px",
                          height: "30px",
                          marginRight: "1rem",
                          border: "1px solid #00000042",
                          background: "transparent",
                          color: FontColors.Black,
                          textAlign: "center",
                          marginTop: "0",
                        }}
                        type={"tel"}
                        maxlength="2"
                        onChange={(event) =>
                          setAchNumberOne(event.target.value)
                        }
                      ></input>
                      <input
                        style={{
                          width: "40px",
                          height: "30px",
                          marginRight: "1rem",
                          border: "1px solid #00000042",
                          background: "transparent",
                          color: FontColors.Black,
                          textAlign: "center",
                          marginTop: "0",
                        }}
                        type={"tel"}
                        maxlength="2"
                        onChange={(event) =>
                          setAchNumberTwo(event.target.value)
                        }
                      ></input>
                      <span style={{ marginRight: "1rem" }}>OR</span>
                      <input
                        style={{
                          width: "120px",
                          height: "30px",
                          marginRight: "1rem",
                          border: "1px solid #00000042",
                          background: "transparent",
                          color: FontColors.Black,
                          textAlign: "center",
                          marginTop: "0",
                        }}
                        type={"tel"}
                        maxlength="6"
                        onChange={(event) => setAchNumberSM(event.target.value)}
                      ></input>
                      <MyButton
                        style={{
                          height: "30px",
                        }}
                        content={"Verify"}
                        onClick={() => handelverifyAch(item)}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: bottomAdd && isSmallScreen ? "100%" : "auto",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span
                          style={{
                            marginLeft: 8,
                            cursor: "pointer",
                            fontWeight: Fonts.GeneralHeaderFont.fontWeight,
                            fontSize: Fonts.GeneralHeaderFont.fontSize,
                            borderRadius: "50%",
                            border: "1px solid #ccc",
                            width: 24,
                            height: 24,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f5f5f5",
                          }}
                          title="How to verify?"
                          onClick={openVerifyInfoModal}
                        >
                          ?
                        </span>
                      </div>
                      <MyModal
                        className="main__alert-dialog"
                        open={openVerifyModal}
                        onClose={closeVerifyInfoModal}
                      >
                        <VerifyAchCardInfo closeModal={closeVerifyInfoModal} />
                      </MyModal>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div
          className="right-side px-0"
          style={{
            minWidth: "216px",
          }}
        >
          {!!achListing.length && (
            <>
              <div className="d-flex">
                <MyCheckbox
                  name={"default"}
                  checked={selectedAch ? selectedAch?.is_default : false}
                  title=""
                  value={selectedAch ? selectedAch?.is_default : false}
                  handlechange={(e) => {
                    setCheckCard(!checkCard);
                  }}
                />
                <LabelField title="Set as default ACH" />
              </div>
            </>
          )}
        </div>
        <div className="my-5 w-100 d-flex col-sm-7 ">
          <div
            className="add-new-payment-info w-100"
            onClick={() => routerHistory.push("/settings?tab=paymentMethods")}
          >
            <span className="add-icon">
              <AddIcon />
            </span>
            <span className="add">Add New ACH</span>
          </div>
        </div>
        {!!achListing?.length && enableInstallments && (
          <div
            className="d-flex align-items-center right-side px-0"
            style={{
              minWidth: "216px",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={
                formik.values?.allowCreditInstallment
                  ? { opacity: 0.7, pointerEvents: "none" }
                  : {}
              }
            >
              <MyCheckbox
                name={"allowAchInstallment"}
                title=""
                value={formik.values.allowAchInstallment}
                handlechange={(e) => {
                  if (!formik?.values?.ach) {
                    formik.setFieldValue("ach", calculateRemainingBalance());
                  }
                  if (e.target.checked) {
                    formik.setFieldValue("allowCreditInstallment", false);
                    formik.setFieldValue("installmentCreditDetails", {
                      cycle: "",
                      frequency: "",
                      startInstallment: new Date(),
                    });
                  }
                  formik.setFieldValue("allowAchInstallment", e.target.checked);
                }}
                disabled={formik.values?.allowCreditInstallment}
              />
              <LabelField title="Pay in Installments" />
            </div>
          </div>
        )}
        <div
          className="right-side px-0"
          style={{
            minWidth: "216px",
            justifyContent: "flex-start",
            display: "flex",
            width: "92%",
          }}
        >
          {!!achListing?.length && isOptionalObject?.coverConvenienceFee && isOptionalObject?.isOptional && (
            <div className="d-flex">
              <MyCheckbox
                name={key}
                checked={formik.values?.[key]}
                handlechange={(e) => {
                  formik.setFieldValue(key, e.target.checked);
                }}
              />
              <LabelField title={isOptionalObject?.message} />
            </div>
          )}
        </div>
      </div>
      {formik.values.allowAchInstallment && enableInstallments && (
        <AddInstallmentsPayment
          formik={formik}
          formikKey="installmentAchDetails"
          installmentFieldLabel="Installments"
          dateFieldLabel="First payment date"
          dateRequired={true}
        />
      )}
      {addNewCard && (
        <div className="row my-5 pb-5">
          <div className="col-sm-4 pr-0 mt-2">
            <div style={{ width: "100%" }}>
              <label
                style={{
                  fontSize: Fonts.GeneralLabelFont.fontSize,
                  textAlign: "start",
                  fontWeight: Fonts.GeneralLabelFont.fontWeight,
                }}
              >
                Account type <span style={{ color: FontColors.RedD32F2F }}>*</span>
              </label>
              <div style={{ width: "100%", position: "relative" }}>
                <select
                  name="account.accountType"
                  value={formik.values?.account?.type || ""}
                  onChange={(e) => onAccountChange(e, "type")}
                  onBlur={() => formik.setFieldTouched("account.type", true)}
                  style={{
                    width: "100%",
                    height: 47,
                    marginTop: 3,
                    boxSizing: "border-box",
                    padding: "10px 40px 10px 12px",
                    borderRadius: 6,
                    border: "1px solid #e6eef9",
                    background: "#fff",
                    fontSize: Fonts.GeneralInputFont.fontSize,
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    cursor: "pointer",
                    backgroundColor: "#F3F6F9",
                    borderColor: "#F3F6F9",
                    color: FontColors.Slate3F4254,
                    transition:
                      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
                  }}
                >
                  <option value="">Select account type</option>
                  <option value="individual">individual</option>
                  <option value="company">company</option>
                </select>
                <div
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    right: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    width: 12,
                    height: 12,
                  }}
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 10l5 5 5-5"
                      stroke="#9fb2d4"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-4 pr-0 mt-2">
            <InputField
              mandatory
              {...{
                formik,
                title: "Account number",
                name: "account.accountNumber",
                type: "string",
                minlength: "16",
                maxLength: "16",
              }}
              id="myInput"
              handleChange={(event) => onAccountChange(event, "number")}
            />
          </div>
          <div className="col-sm-4 pr-0 mt-2">
            <InputField
              mandatory
              {...{
                formik,
                title: "Routing number",
                name: "account.routingNumber",
                type: "string",
                minlength: "16",
                maxLength: "16",
              }}
              handleChange={(event) => onAccountChange(event, "routing")}
              id="myInput"
            />
          </div>
          <div className="col-sm-4 pr-0 mt-2">
            <InputField
              mandatory
              {...{
                formik,
                title: "Name on account",
                name: `account.nameOnAccount`,
                placeholder: "",
              }}
              handleChange={(event) => onAccountChange(event, "name")}
            />
          </div>
          <div
            className="col-sm-4"
            style={{
              marginTop: "3rem",
            }}
          >
            <MyButton
              content={"Save Account"}
              style={{ width: 120 }}
              onClick={onSaveAccount}
            />
          </div>
          <div className="col-sm-4 pr-0 mt-2">
            <InputField
              mandatory
              {...{
                formik,
                title: "Routing number",
                name: "account.routingNumber",
                type: "string",
                minlength: "16",
                maxLength: "16",
              }}
              handleChange={(event) => onAccountChange(event, "routing")}
              id="myInput"
            />
          </div>
          <div className="col-sm-4 pr-0 mt-2">
            <InputField
              mandatory
              {...{
                formik,
                title: "Name on account",
                name: `account.nameOnAccount`,
                placeholder: "",
              }}
              handleChange={(event) => onAccountChange(event, "name")}
            />
          </div>
          <div
            className="col-sm-4"
            style={{
              marginTop: "3rem",
            }}
          >
            <MyButton
              content={"Save Account"}
              style={{ width: 120 }}
              onClick={onSaveAccount}
            />
          </div>
        </div>
      )}
      <AlertDialog
        open={openAlert}
        onDecline={closeConfirmDialog}
        onAccept={() => {
          onDeleteAch(achId);
        }}
        title={"Are you sure?"}
        description={"Do you want to delete this card?"}
      />
    </>
  );
};
export const ACHHeader = ({ formik, ...props }) => {
  const { expanded, current } = props;
  const currency = getCurrency();

  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };

  const handleOnChange = (event) => {
    formik.setFieldValue("ach", event.target.value);
  };

  return (
    <div
      className={
        expanded === false && current?.includes("ach") === true
          ? "accordion-header achPayment"
          : expanded === false
          ? "accordion-payment-header achPayment"
          : expanded === true
          ? "accordion-header achPayment"
          : "accordion-header-payment achPayment"
      }
    >
      <div className="d-flex">
        <LabelField title="ACH" />
      </div>
      <div
        className={
          expanded === false && current?.includes("ach")
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount "
            : "col-sm-2"
        }
      >
        {expanded === false &&
        current?.includes("ach") &&
        formik?.values?.ach ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>{formik.values?.ach}.00</span>
          </div>
        ) : current?.includes("ach") && expanded === true ? (
          <InputField
            {...{
              formik,
              title: "none",
              name: `val`,
              style: { background: "#ffff", border: "none" },
              value: formik.values?.ach,
              placeholderIcon: (
                <span
                  className="align-self-center px-4"
                  style={{ color: FontColors.Black }}
                >
                  {currency}
                </span>
              ),
            }}
            handleFocus={(e) => handlefieldClick(e)}
            paymentInput="paymentInput"
            // onKeyDown={preventMinus}
            handleChange={(event) => handleOnChange(event)}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
